import React from "react";
import { Spinner } from "reactstrap";

const Direction = () => {
  return (
    <section className="space-top space-extra-bottom">
      {/* {loader && <div classNameName="formLoader"><Spinner /></div>} */}
      {/* <style>
        {`
          .gm-style .gm-style-iw-c {
            display: none !important;
          }
          .gm-style .gm-style-iw {
            display: none !important;
          }
          .gm-style .gm-style-iw-t {
            display: none !important;
          }
          .gm-style .gm-ui-hover-effect {
            display: none !important;
          }
          .gm-style .gm-style-iw-d {
            display: none !important;
          }
          .gm-style .gm-style-iw-tc {
            display: none !important;
          }
          .gmnoprint {
            display: none !important;
          }
          .gm-style-cc {
            display: none !important;
          }
          .gm-bundled-control {
            display: none !important;
          }
          .gm-control-active {
            display: none !important;
          }
        `}
      </style> */}
      <div className="">
        <div className="title-area2 text-center">
          <h4 className="sec-title-ndm">OUR EVENT LOCATION</h4>
          <span className="sub-title2">GET DIRECTION TO THE EVENT</span>
        </div>
        <div className="row">
          <div className="col-xl-12 mb-35" style={{ position: "relative" }}>
            <div className="d-flex justify-content-center">
              <div
                className="location-card-wrap background-image"
                style={{
                  // backgroundImage: "url(./img/Venue-backgruond.jpg)",
                  background: "white",
                  maxWidth: "300px",
                  height: "300px",
                  width: "100%",
                  position: "absolute",
                  top: "100px",
                  left: "25%",
                  color: "black",
                  boxShadow:
                    "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
                  transform: "translateX(-50%)",
                  zIndex: 1000,
                }}
              >
                <div
                  className="vs-carousel slick-initialized slick-slider"
                  data-asnavfor="#mapSlide"
                  id="locationSlide"
                  data-fade="true"
                  data-slide-show="1"
                  data-md-slide-show="1"
                >
                  <div className="slick-list draggable">
                    <div
                      className="slick-track"
                      style={{ opacity: 1, width: "574px" }}
                    >
                      <div
                        className="location-card slick-slide slick-current slick-active"
                        style={{
                          width: "100%",
                          position: "relative",
                          left: "0px",
                          top: "0px",
                          zIndex: 999,
                          opacity: 1,
                        }}
                        tabindex="0"
                        data-slick-index="0"
                        aria-hidden="false"
                      >
                        <h4 className="location-title">VENUE</h4>
                        <div className="">
                          <span className="info-title">
                            Pandit Deendayal Upadhyay <br></br>Auditorium,
                          </span>
                          <p className="info-text">
                            Great Eastern Road, Amanaka,<br></br>
                            Raipur 492010<br></br>
                          </p>
                        </div>

                        <a
                          href="https://maps.app.goo.gl/CmsBFtB3piGWyT2SA"
                          target="_blank"
                          className="btn-grad text-white mt-3"
                          tabindex="0"
                        >
                          Get Directions
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="vs-icon-box d-none">
                  <button
                    data-slick-prev="#locationSlide"
                    className="simple-icon arrow-left"
                  >
                    <i className="fa fa-arrow-left"></i>
                  </button>
                  <button
                    data-slick-next="#locationSlide"
                    className="simple-icon arrow-right"
                  >
                    <i className="fa fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-12 justify-content-center d-flex"
            style={{ position: "relative" }}
          >
            <div className="map-slide-wrap col-xl-12">
              <div
                className="vs-carousel slick-initialized slick-slider"
                data-asnavfor="#locationSlide"
                id="mapSlide"
                data-fade="true"
                data-slide-show="1"
                data-md-slide-show="1"
              >
                <div className="slick-list draggable">
                  <div
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      width: "100%",
                      height: "500px",
                    }}
                  >
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3718.5746434871453!2d81.6013722!3d21.2487094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28de099a9570b5%3A0xe3075542a0f16922!2sPandit%20Dindayal%20Upadhyay%20Auditorium%20Raipur!5e0!3m2!1sen!2sin!4v1752579785899!5m2!1sen!2sin"
                      style={{
                        position: "absolute",
                        top: "-80px", // Adjust this value to hide top elements
                        left: "-10px", // Adjust this value to hide left elements
                        width: "calc(100% + 20px)",
                        height: "calc(100% + 160px)",
                        border: "none",
                        filter: "grayscale(30%) contrast(110%)", // Optional styling
                      }}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      allowFullScreen
                      className="slick-slide slick-current slick-active"
                      tabIndex="0"
                      data-slick-index="0"
                      aria-hidden="false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Direction;
